import React, { useState, useEffect } from 'react';

import ModalWarn from '../../Components/Modal/Warn/index'
import ShowUnitElement from '../../Components/ShowUnitElement'
import { estados } from '../../constants'

export default function DeleteUnit(props) {
    const [ unit, setUnit ] = useState({
        organCode: '',
        unitCode: '',
        unitName: '',
        state: '',
        street: '',
        number: '',
        city: '',
        municipality: '',
        neighborhood: '',
        addressComplement: '',
        enableCitizenOrAttorneyFingerprintVerify: false,
        enableAuthorizedCertificateLoginOnly: false,
        mobileServiceUnit: false
    });
    const [ userList, setUserList ] = useState([]);    
    const [ userListAttendant, setUserListAttendant ] = useState([]);

    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)
    const [ isModalConfirmVisible, setModalConfirmVisible ] = useState(false);
    const [ loadingDelete, setLoadingDelete ] = useState(false);
    const [ deleted, setDeleted ] = useState(false);
    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");
    const [ erroMsg, setErroMsg ] = useState([]);
    const [ modalUserMigrationWarning, setModalUserMigrationWarning ] = useState(false);
    const [ messageModalUserMigrationWarning, setMessageModalUserMigrationWarning ] = useState("");
    const [ pageOptions, setPageOptions ] = useState([]);
    const [ page, setPage ] = useState({
        label: "1", value: "1"
    });
    const [ totalFilter, setTotalFilter ] = useState("0");
    const [ rangePages, setRangePages ] = useState({
        label: "10", value: "10"
    });

    
    const [ pageOptionsAttendant, setPageOptionsAttendant ] = useState([]);
    const [ pageAttendant, setPageAttendant ] = useState({
        label: "1", value: "1"
    });
    const [ totalFilterAttendant, setTotalFilterAttendant ] = useState("0");
    const [ rangePagesAttendant, setRangePagesAttendant ] = useState({
        label: "10", value: "10"
    });
    
    useEffect(() => {   
        if (props.location.state !== undefined) {
            if (props.location.state.result_search !== undefined) { //Vem da página de consulta
                setUnit({
                    organCode: props.location.state.result_search.CODIGO_ORGAO,
                    unitCode: props.location.state.result_search.CODIGO_UNIDADE,
                    unitName: props.location.state.result_search.NOME_UNIDADE,
                    state: estados.filter(option => option.value === props.location.state.result_search.ESTADO)[0],
                    street: props.location.state.result_search.LOGRADOURO,
                    number: props.location.state.result_search.NUMERO,
                    city: props.location.state.result_search.CIDADE,
                    municipality: props.location.state.result_search.NOME_MUNICIPIO,
                    neighborhood: props.location.state.result_search.BAIRRO,
                    addressComplement: props.location.state.result_search.COMPLEMENTO,
                    zipcode: props.location.state.result_search.CEP,
                    enableCitizenOrAttorneyFingerprintVerify: (props.location.state.result_search.HABILITA_BIOMETRIA_CIDADAO === 'S' ? true : false),
                    enableAuthorizedCertificateLoginOnly: (props.location.state.result_search.LOGIN_APENAS_POR_CERT_AUTORI === 'S' ? true : false),
                    mobileServiceUnit: (props.location.state.result_search.ATENDIMENTO_MOVEL === 'S' ? true : false)
    
                });
            } else { //Vem do botão voltar
                setUnit(props.location.state);
            }            

           onChangePaginationConfig(rangePages, null, true)
           onChangePaginationConfigAttendant(rangePagesAttendant, null, true)

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.state]);

    const onChangePaginationConfig = async (ranPag, pag, isRanPag) => {
        setErroMsg(undefined);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                codigo_unidade: props.location.state.result_search?.CODIGO_UNIDADE || props.location.state.unitCode,
                pagina_atual: isRanPag ? "1" : pag.value,
                qtd_registros: ranPag.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/listaGestoresRegionaisAssociadosAUnidade`,
                    requestOptions
            ).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        const maxPageOption = Math.ceil(Number(data.total) / Number(ranPag.value))
                        let list = []
                        let obj = {}
                        for(var i = 1; i <= maxPageOption; i++) {
                            obj = {
                                value: String(i),
                                label: String(i)
                            }

                            list.push(obj);
                        }

                        setPageOptions(list);
                        if(isRanPag){
                            setPage({label: "1", value: "1"});
                        }
                        setUserList(data.usuarios);
                        setTotalFilter(data.total);
                    });
                } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (!!data.errorCode && !!data.message) {
                            setErroMsg(data.message)
                            setMessageError(data.message)
                        } else {
                            setErroMsg('Houve algum problema no servidor.');
                        }
                        //setLoading(false);
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                    setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                    setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                    setModalInvalidSessionError(true)
                    })
                } else {
                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                    //setLoading(false);
                    console.log('Request error in gestao/listaGestoresRegionaisAssociadosAUnidade BackendBalcao');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
    };




    const onChangePaginationConfigAttendant = async (ranPag, pag, isRanPag) => {
        setErroMsg(undefined);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                codigo_unidade: props.location.state.result_search?.CODIGO_UNIDADE || props.location.state.unitCode,
                pagina_atual: isRanPag ? "1" : pag.value,
                qtd_registros: ranPag.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/listaAtendentesAssociadosAUnidade`,
                    requestOptions
            ).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        const maxPageOption = Math.ceil(Number(data.total) / Number(ranPag.value))
                        let list = []
                        let obj = {}
                        for(var i = 1; i <= maxPageOption; i++) {
                            obj = {
                                value: String(i),
                                label: String(i)
                            }

                            list.push(obj);
                        }

                        setPageOptionsAttendant(list);
                        if(isRanPag){
                            setPageAttendant({label: "1", value: "1"});
                        }
                        setUserListAttendant(data.usuarios);
                        setTotalFilterAttendant(data.total);
                    });
                } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (!!data.errorCode && !!data.message) {
                            setErroMsg(data.message)
                            setMessageError(data.message)
                        } else {
                            setErroMsg('Houve algum problema no servidor.');
                        }
                        //setLoading(false);
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                    setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                    setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                    setModalInvalidSessionError(true)
                    })
                } else {
                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                    //setLoading(false);
                    console.log('Request error in gestao/listaAtendentesAssociadosAUnidade BackendBalcao');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
    };    

    const onSubmitDelete = async () => {
        setModalConfirmVisible(false)
        setLoadingDelete(true);

        const requestOptions = {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",
                codigo_orgao: unit.organCode,
                codigo_unidade: unit.unitCode,
                nome_unidade: unit.unitName
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/removeUnidadeOrgao`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data_request) {   
                    const unit_deleted = {
                        message: data_request.message
                    }                 
                    setDeleted(true);
                    setLoadingDelete(false);
                    setModalConfirmVisible(false)
                    props.history.push('gerenciarUnidades', unit_deleted);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        if (data.errorCode === 'UNIT_USER_MUSTBELONGTOAUNIT') {
                            setMessageModalUserMigrationWarning(data.message);
                            setModalUserMigrationWarning(true);
                        } else {
                            setMessageError(data.message); // inserir a mensagem: data.message no aviso de erro
                            setModalError(true);
                        }                    
                    } else {
                        // inserir mensagem genérica
                        setMessageError('Houve algum problema no servidor.');
                        setModalError(true);
                    }

                    setLoadingDelete(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingDelete(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingDelete(false);
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <ShowUnitElement
                pageTitle='Remover Unidade'
                isModalConfirmVisible={isModalConfirmVisible}
                setModalConfirmVisible={setModalConfirmVisible}
                loadingDelete={loadingDelete}
                onSubmitDelete={onSubmitDelete}
                deleted={deleted}

                unit={unit}
                setUnit={setUnit}
                tableResultListTitle='Gestores regionais vinculados'
                onChangePaginationConfig={onChangePaginationConfig}
                totalFilter={totalFilter}
                searchResult={userList}
                pageOptions={pageOptions}
                setPage={setPage}
                page={page}
                erroMsg={erroMsg}
                rangePages={rangePages}
                setRangePages={setRangePages}
                modalError ={modalError}
                setModalError={setModalError}
                messageError={messageError}
                setModalUserMigrationWarning = {setModalUserMigrationWarning}
                modalUserMigrationWarning = {modalUserMigrationWarning}
                messageModalUserMigrationWarning = {messageModalUserMigrationWarning}
                buttonUserMigrationRoute='/migracaoEntreUnidades'
                buttonCancelRoute='/gerenciarUnidades'
                history={props.history}

                tableResultListTitleAttendant='Atendentes vinculados'
                onChangePaginationConfigAttendant={onChangePaginationConfigAttendant}
                searchResultAttendant={userListAttendant}
                rangePagesAttendant={rangePagesAttendant}
                setRangePagesAttendant={setRangePagesAttendant}
                pageAttendant={pageAttendant}
                setPageAttendant={setPageAttendant}
                totalFilterAttendant={totalFilterAttendant}
                pageOptionsAttendant={pageOptionsAttendant}

                
            />
        </>
    );
}